"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const SyncFailure_vue_1 = tslib_1.__importDefault(require("../SyncFailure.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
exports.default = vue_1.default.extend({
    name: 'check-sync-result',
    props: {},
    computed: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        url() {
            switch (true) {
                case this.$store.getters.isRegistering:
                    return `${this.baseUrl}Registration`;
                case this.$store.getters.isForgotPasswordWorkflow:
                    return `${this.baseUrl}ForgotPassword`;
            }
            return `${this.baseUrl}ForgotPassword`;
        },
    },
    components: {
        ContainerSlide: ContainerSlide_vue_1.default,
        SyncFailure: SyncFailure_vue_1.default,
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
    },
});
